"use client";

import { motion } from "framer-motion";
import * as Tabs from "@radix-ui/react-tabs";

interface TabItemProps {
  value: string;
  title: string;
  isSelected: boolean;
  onClick: (tab: string) => void;
}

export function TabItem({ title, value, isSelected, onClick }: TabItemProps) {
  return (
    <Tabs.Trigger
      value={value}
      onClick={() => onClick(value)}
      className="group relative px-1 pb-3.5 text-sm font-medium leading-5 text-zinc-500 outline-none transition-colors duration-200 data-[state=active]:text-apcap hover:text-zinc-800 dark:text-zinc-400 dark:data-[state=active]:text-emerald-400 dark:hover:text-zinc-200"
    >
      <span className="whitespace-nowrap rounded-md px-1 group-focus-visible:ring-2 group-focus-visible:ring-apcap/40 group-focus-visible:ring-offset-2 dark:group-focus-visible:ring-offset-zinc-950">
        {title}
      </span>

      {isSelected && (
        <motion.div
          layoutId="activeTab"
          className="absolute -bottom-px left-0 right-0 h-0.5 rounded-full bg-apcap dark:bg-emerald-400"
          transition={{ type: "spring", stiffness: 380, damping: 30 }}
        />
      )}
    </Tabs.Trigger>
  );
}
